import { GET_ALL_BEDSTATUS, UPDATE_BEDSTATUS } from '../../constant';

const allBedStatusData = [
  { id: 1, status: ['ManOccupied'], value: '01' },
  { id: 2, status: ['ManOccupied'], value: '02' },
  { id: 3, status: ['ManOccupied'], value: '03' },
  { id: 4, status: ['ManOccupied'], value: '04' },
  { id: 5, status: ['ManOccupied'], value: '05' },
  { id: 6, status: ['ManOccupied'], value: '06' },
  { id: 7, status: ['ManOccupied'], value: '07' },
  { id: 8, status: ['ManOccupied'], value: '08' },
  { id: 9, status: ['ManOccupied'], value: '09' },
  { id: 10, status: ['ManOccupied'], value: '10' },
  { id: 11, status: ['ManOccupied'], value: '11' },
  { id: 12, status: ['Vacant'], value: '12' },
  { id: 13, status: ['ManOccupied'], value: '13' },
  { id: 14, status: ['ManOccupied'], value: '14' },
  { id: 15, status: ['Discharging', 'ManOccupied'], value: '15' },
  { id: 16, status: ['Vacant'], value: '16' },
  { id: 17, status: ['Vacant'], value: '17' },
  { id: 18, status: ['Discharging', 'ManOccupied'], value: '18' },
  { id: 19, status: ['ManOccupied'], value: '19' },
  { id: 20, status: ['ManOccupied'], value: '20' },
  { id: 21, status: ['Unavailable'], value: '21' },
  { id: 22, status: ['ManOccupied'], value: '22' },
  { id: 23, status: ['ManOccupied'], value: '23' },
  { id: 24, status: ['ManOccupied'], value: '24' },
  { id: 25, status: ['Unavailable'], value: '25' },
  { id: 26, status: ['ManOccupied'], value: '26' },
  { id: 27, status: ['ManOccupied'], value: '27' },
  { id: 28, status: ['ManOccupied'], value: '28' },
  { id: 29, status: ['ManOccupied'], value: '29' },
  { id: 30, status: ['FemaleOccupied'], value: '30' },
  { id: 31, status: ['FemaleOccupied'], value: '31' },
  { id: 32, status: ['Vacant'], value: '32' },
  { id: 33, status: ['Discharging', 'FemaleOccupied'], value: '33' },
  { id: 34, status: ['Unavailable', 'Maintanience', 'Resusitation', 'Contact precaution'], value: '34' },
  { id: 35, status: ['Unavailable'], value: '35' },
  { id: 36, status: ['FemaleOccupied'], value: '36' },
  { id: 37, status: ['Unavailable'], value: '37' },
  { id: 38, status: ['FemaleOccupied'], value: '38' },
  { id: 39, status: ['Unavailable'], value: '39' },
  { id: 40, status: ['Vacant'], value: '40' },
  { id: 41, status: ['FemaleOccupied'], value: '41' },
  { id: 42, status: ['FemaleOccupied'], value: '42' },
  { id: 43, status: ['FemaleOccupied'], value: '43' },
  { id: 44, status: ['FemaleOccupied'], value: '44' },
  { id: 45, status: ['FemaleOccupied'], value: '45' },
  { id: 46, status: ['Unavailable', 'Maintanience', 'Resusitation', 'Contact precaution'], value: '46' },
  { id: 47, status: ['Unavailable'], value: '47' },
  { id: 48, status: ['FemaleOccupied'], value: '48' },
  { id: 49, status: ['Missing （closed case)'], value: '49' },
  { id: 50, status: ['ManOccupied'], value: '50' },
  { id: 51, status: ['FemaleOccupied'], value: '51' },
  { id: 52, status: ['Missing'], value: '52' },
  { id: 53, status: ['FemaleOccupied'], value: '53' },
  { id: 54, status: ['Vacant'], value: '54' },
  { id: 55, status: ['FemaleOccupied'], value: '55' },
  { id: 56, status: ['Unavailable'], value: '56' },
  { id: 57, status: ['FemaleOccupied'], value: '57' },
  { id: 58, status: ['FemaleOccupied'], value: '58' },
  { id: 59, status: ['FemaleOccupied'], value: '59' },
  { id: 60, status: ['FemaleOccupied'], value: '60' },
  { id: 61, status: ['FemaleOccupied'], value: '61' },
  { id: 62, status: ['Vacant'], value: '62' },
  { id: 63, status: ['FemaleOccupied'], value: '63' },
  { id: 64, status: ['FemaleOccupied'], value: '64' },
  { id: 65, status: ['BedTBC'], value: '65' },
  { id: 66, status: ['FemaleOccupied'], value: '66' },
  { id: 67, status: ['FemaleOccupied'], value: '67' },
  { id: 68, status: ['FemaleOccupied'], value: '68' },
  { id: 69, status: ['FemaleOccupied'], value: '69' },
  { id: 70, status: ['FemaleOccupied'], value: '70' },
];

const bedStatus = (state = allBedStatusData, action) => {
  const { type, data } = action;
  switch (type) {
    case GET_ALL_BEDSTATUS:
      return state;
    case UPDATE_BEDSTATUS:
      return state.map((item) => {
        return item.id === data.id ? data : item;
      });
    default:
      return state;
  }
};

export { bedStatus };
